import { render, staticRenderFns } from "./FbPictureTag.vue?vue&type=template&id=848504f8&scoped=true"
import script from "./FbPictureTag.vue?vue&type=script&lang=js"
export * from "./FbPictureTag.vue?vue&type=script&lang=js"
import style0 from "./FbPictureTag.vue?vue&type=style&index=0&id=848504f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848504f8",
  null
  
)

export default component.exports